import type { LucideIcon } from 'lucide-react'
import { cn } from '@merels/ui'

export interface ToolSubtab {
  id: string
  name: string
  Icon: LucideIcon
}

interface ToolSubtabsProps {
  tools: ToolSubtab[]
  activeToolId: string
  onSelect: (toolId: string) => void
}

/** Secondary navigation for the Debugging and Platform Creator Panel tabs. */
export function ToolSubtabs({ tools, activeToolId, onSelect }: ToolSubtabsProps) {
  return (
    <div
      className="flex items-center gap-1 overflow-x-auto px-1"
      role="tablist"
      aria-label="Section tools"
    >
      {tools.map(({ id, name, Icon }) => {
        const isActive = activeToolId === id
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-label={name}
            title={name}
            onClick={() => onSelect(id)}
            className={cn(
              'group relative flex h-8 w-8 flex-shrink-0 items-center justify-center rounded transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus',
              isActive
                ? 'bg-accent/15 text-accent'
                : 'text-muted hover:bg-muted-bg/30 hover:text-primary',
            )}
          >
            <Icon className="h-4 w-4" strokeWidth={isActive ? 2.75 : 2} aria-hidden="true" />
            <span className="pointer-events-none absolute left-1/2 top-9 z-50 -translate-x-1/2 whitespace-nowrap rounded border border-basic bg-surface px-1.5 py-0.5 text-[10px] font-semibold text-primary opacity-0 shadow transition-opacity group-hover:opacity-100">
              {name}
            </span>
          </button>
        )
      })}
    </div>
  )
}
